export default __webpack_public_path__ + "static/media/radio.54bc5bfe.svg";